import axios from 'axios'
import api from '@/api'

const patientsDecisions = {
  state: {
    data: []
  },
  getters: {
    getPatientsDecisionsData: state => state.data.data_fields,
    getPatientsSpecializationDecisionsData: state => state.data.specializations,
  },
  mutations: {
    PATIENT_DECISIONS_GET (state, payload) {
      state.data = payload
    },
  },
  actions: {
    patientsDecisionEditGet (context, value) {
      axios({
        method: 'POST',
        url: `${api}pdf-templates/` + value.id,
        data: {
          patient_id: value.patient
        }
      }).then(response => {
        context.commit('PATIENT_DECISIONS_GET', response.data.data);
      }).catch((error) => {
        console.log(error);
      })
    }
  }
};
export default patientsDecisions
